module.exports = __webpack_public_path__ + "static/flavor_wheel-19a6d5ab24bbc3b3531f11ecab349683.jpg";